import { useAction } from "../../shared/hooks";
import type { PreparedLoginDevice } from "../trusted-device-ladder";
import { prepareTrustedLoginDevice } from "../trusted-device-ladder";
import type { TrustedDeviceChallenge } from "@core/account/types";

/**
 * Prepare automatic trusted-browser enrollment or proof during login.
 *
 * Thin React wrapper over {@link prepareTrustedLoginDevice}, which walks the
 * WebCrypto → extractable JWK → device cookie ladder.
 */
export function useTrustedDeviceLogin() {
  const requestChallenge = useAction<TrustedDeviceChallenge>(
    "/auth/login/device/challenge",
  );

  const prepareLoginDevice = (): Promise<PreparedLoginDevice> =>
    prepareTrustedLoginDevice({ requestChallenge });

  return { prepareLoginDevice };
}
